import { LoadingState, } from './types.js';
export const isNotLoaded = (entity) => entity == null ? true : entity.loadingState === LoadingState.NotLoaded;
export const isLoading = (entity) => entity == null ? false : entity.loadingState === LoadingState.Loading;
export const isLoaded = (entity) => entity == null ? false : entity.loadingState === LoadingState.Loaded;
export const isReloading = (entity) => entity == null ? false : entity.loadingState === LoadingState.Reloading;
export const isError = (entity) => entity == null ? false : entity.loadingState === LoadingState.Error;
export const isPartialLoading = (entity) => entity == null ? false : entity.loadingState === LoadingState.LoadingPartial;
export const isPartialError = (entity) => entity == null ? false : entity.loadingState === LoadingState.ErrorPartial;
export const hasData = (entity) => entity == null
    ? false
    : entity.loadingState === LoadingState.Loaded ||
        entity.loadingState === LoadingState.Reloading ||
        entity.loadingState === LoadingState.LoadingPartial ||
        entity.loadingState === LoadingState.ErrorPartial;
//# sourceMappingURL=helpers.js.map